import { useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { MdMailOutline } from "react-icons/md";
import ForgotImg from "../../../images/forgot_password.svg";
import MailSent from "../../../images/email.svg";
import { Input, Loading } from "../../common";
import { ImgContainer, NotReceived } from "./styles";
import { useStyles } from "../styles";
import { requestPassReset } from "../../../reducers/auth/thunks";
import { AuthTypes } from "../../../reducers/auth/types";

export function ForgotPassword({
  opened,
  requestPassReset,
  closeForgotPassModal,
  loading,
  success,
  changeSuccess,
}) {
  const [email, setEmail] = useState("");

  const classes = useStyles();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleClose = () => {
    closeForgotPassModal();
  };
  const handleResendEmail = () => {
    changeSuccess();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    requestPassReset(email);
  };

  return (
    <>
      <Dialog
        open={!!opened}
        onClose={handleClose}
        aria-labelledby="email-verification-sent-title"
        aria-describedby="email-verification-sent-description"
        maxWidth="xs"
        style={{
          textAlign: "center",
        }}
      >
        <DialogTitle id="email-verification-sent-dialog-title">
          Forgot password?
        </DialogTitle>
        <DialogContent>
          <ImgContainer>
            <img
              src={success ? MailSent : ForgotImg}
              alt="forgot password svg"
            />
          </ImgContainer>
          {success ? (
            <DialogContentText
              id="email-verification-sent-dialog-description"
              style={{ fontSize: "13px" }}
            >
              Success! We've sent an email to{" "}
              <strong>
                <i>{email}</i>
              </strong>
              , click the link inside it to reset your password. If it doesn’t
              appear within a few minutes, check your spam folder.
            </DialogContentText>
          ) : (
            <>
              <DialogContentText id="email-verification-sent-dialog-description">
                Please, enter your email address to receive a verification code
              </DialogContentText>
              <form onSubmit={handleSubmit}>
                <Input
                  name="email"
                  value={email}
                  onChange={handleChange}
                  type="email"
                  icon={<MdMailOutline />}
                  placeholder="Email Address"
                  required
                />
                <Button
                  className={classes.button}
                  type="submit"
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                >
                  Send password reset email
                </Button>
              </form>
            </>
          )}
          {success && (
            <NotReceived>
              <p>Didn't get the email?</p>
              <strong onClick={handleResendEmail}>Resend</strong>
            </NotReceived>
          )}
        </DialogContent>
      </Dialog>
      <Loading backdrop loading={loading} />
    </>
  );
}

const mapState = (state) => ({
  opened: state.auth.isForgotPassModalOpened,
  loading: state.auth.loading,
  success: state.auth.passwordResetSent,
});

const mapDispatch = (dispatch) => ({
  requestPassReset: (email) => dispatch(requestPassReset(email)),
  closeForgotPassModal: () => dispatch({ type: AuthTypes.CLOSE_FORGOT_PASS }),
  changeSuccess: () => dispatch({ type: AuthTypes.RESET_PASSWORD.FAILURE }),
});

export default connect(mapState, mapDispatch)(ForgotPassword);
